import { useSelector, useDispatch } from 'react-redux';
import { useAuthN } from '../authN/useAuthN';
import * as applicationsActions from '../redux/actions/applicationsActions.Thunks';
import * as currentUserActions from '../redux/actions/currentUserActions.Thunks';

//this is a hook
export const useApplicationsLogic = () => {
	const user = useSelector((state) => state.user);

	const dispatch = useDispatch();
	const { getAccessToken, isInProgress, isAuthenticated } = useAuthN();

	const getApplications = async () => {
		if (isAuthenticated && !isInProgress) {
			const atResponse = await getAccessToken(APIS.lp.scopes);
			const applications = await dispatch(
				applicationsActions.getApplications(atResponse.accessToken, user.enterpriseProfileId)
			);
			return applications;
		}
	};

	const createApplication = async (createApplication) => {
		if (isAuthenticated && !isInProgress && user) {
			const atResponse = await getAccessToken(APIS.lp.scopes);
			try {
				await dispatch(
					applicationsActions.createApplication(atResponse.accessToken, user.enterpriseProfileId, createApplication)
				);
				return true;
			} catch {
				return false;
			}
		}
	};

	const updateApplicationVisibility = async (application) => {
		if (isAuthenticated && !isInProgress && user) {
			const atResponse = await getAccessToken(APIS.lp.scopes);
			try {
				await dispatch(
					applicationsActions.updateApplicationVisibility(atResponse.accessToken, user.enterpriseProfileId, application)
				);
				return true;
			} catch {
				return false;
			}
		}
	};

	const updateApplication = async (application) => {
		if (isAuthenticated && !isInProgress && user) {
			const atResponse = await getAccessToken(APIS.lp.scopes);
			try {
				await dispatch(
					applicationsActions.updateApplication(atResponse.accessToken, user.enterpriseProfileId, application)
				);
				return true;
			} catch {
				return false;
			}
		}
	};

	const deleteApplication = async (application) => {
		if (isAuthenticated && !isInProgress && user) {
			const atResponse = await getAccessToken(APIS.lp.scopes);
			try {
				await dispatch(
					applicationsActions.deleteApplication(atResponse.accessToken, user.enterpriseProfileId, application)
				);
				return true;
			} catch {
				return false;
			}
		}
	};

	const addFavoriteApp = async (favoriteAppId) => {
		if (isAuthenticated && !isInProgress && user) {
			const atResponse = await getAccessToken(APIS.lp.scopes);
			try {
				await dispatch(
					currentUserActions.addFavoriteApp(atResponse.accessToken, user.enterpriseProfileId, favoriteAppId)
				);
				return true;
			} catch {
				return false;
			}
		}
	};

	const deleteFavoriteApp = async (favoriteAppId) => {
		if (isAuthenticated && !isInProgress && user) {
			const atResponse = await getAccessToken(APIS.lp.scopes);
			try {
				await dispatch(
					currentUserActions.deleteFavoriteApp(atResponse.accessToken, user.enterpriseProfileId, favoriteAppId)
				);
				return true;
			} catch {
				return false;
			}
		}
	};

	const updateInternalAppOrder = async (appOrderArray) => {
		if (isAuthenticated && !isInProgress && user) {
			const atResponse = await getAccessToken(APIS.lp.scopes);
			try {
				await dispatch(
					currentUserActions.setInternalAppOrder(atResponse.accessToken, user.enterpriseProfileId, appOrderArray)
				);
				return true;
			} catch {
				return false;
			}
		}
	};

	const updateExternalAppOrder = async (appOrderArray) => {
		if (isAuthenticated && !isInProgress && user) {
			const atResponse = await getAccessToken(APIS.lp.scopes);
			try {
				await dispatch(
					currentUserActions.setExternalAppOrder(atResponse.accessToken, user.enterpriseProfileId, appOrderArray)
				);
				return true;
			} catch {
				return false;
			}
		}
	};

	return {
		getApplications,
		createApplication,
		updateApplicationVisibility,
		updateApplication,
		deleteApplication,
		addFavoriteApp,
		deleteFavoriteApp,
		updateInternalAppOrder,
		updateExternalAppOrder
	};
};
